<template>
  <div>
    <div class="container">

      <Tabs>
        <TabSection :title="$t('role_permissions.title')">
          <div class="columns">
            <div class="column">
              <div class="group">
                <label>{{ $t('user.role') }}</label>
                <select v-model="focused">
                  <option v-for="rp of rolePermissions" :value="rp">{{ $t(`roles.${rp.role}`) }}</option>
                </select>
              </div>
            </div>
            <div class="column">
              <template v-if="focused">
                <div class="group">
                  <label>{{ $t('role_permissions.list') }}</label>
                  <select v-model="focused.blacklisted">
                    <option :value="true">{{ $t('role_permissions.black_list') }}</option>
                    <option :value="false">{{ $t('role_permissions.white_list') }}</option>
                  </select>
                </div>
                <div class="group" v-for="pn of permissionNames">
                  <input :id="`chk_${pn.id}`" :value="pn.id" v-model="focused.list" type="checkbox">
                  <label :for="`chk_${pn.id}`">{{ $t(pn.tr) }}</label>
                </div>
              </template>
            </div>
          </div>
          <div style="text-align: center">
            <button class="btn btn-primary" @click="save">{{ $t('save') }}</button>
          </div>
        </TabSection>
      </Tabs>

    </div>
  </div>
</template>

<script>
  import { Core } from "@/core/Core";

  export default {
    name: "RolePermissions",

    data() {
      return {
        permissionNames: [
          { id: 'emergency_closure', tr: 'quick_config.select.emergency_closure' },
          { id: 'by_pass_pos', tr: 'quick_config.select.by_pass_pos' },
          { id: 'preparation_delays', tr: 'quick_config.select.preparation_delays' },
          { id: 'opening_hours', tr: 'quick_config.select.opening_hours' },
          { id: 'snooze_item', tr: 'quick_config.select.snooze_item' }
        ],
        rolePermissions: [],
        roleNames: [],
        focused: null,
      }
    },
    async mounted() {
      this.$store.state.pageTitleTranslationKey = "settings.role_permissions";
      this.$store.state.pageIcon = "";

      let company = parseInt(this.$route.query.company)
      this.roleNames = ['ROLE_RECEPTION', 'ROLE_POS', 'ROLE_CLERK']
      this.rolePermissions = this.roleNames.map(r => ({
        id: null,
        company: company,
        role: r,
        blacklisted: true,
        list: []
      }));

      this.$store.commit('showSpinner', true);
      let response = await Core.request('GET', '/api/company_role_permissions', { company })
      this.$store.commit('showSpinner', false);

      for (let row of response.data) {
        let found = this.rolePermissions.find(p => p.role === row.role)
        if (found) {
          Object.assign(found, row)
        } else {
          this.roleNames.push(row.role)
          this.rolePermissions.push(row)
        }
      }
    },

    methods: {
      async save() {
        let responses = await Promise.all(
          this.rolePermissions
            .filter(p => p.id || !(p.blacklisted && !p.list.length))
            .map(p => p.id
              ? Core.request('PUT', `/api/company_role_permissions/${p.id}`, p)
              : Core.request('POST', '/api/company_role_permissions', p)
            )
        )
        for (let row of responses) {
          let found = this.rolePermissions.find(p => p.role === row.role)
          Object.assign(found, row)
        }
        toast(this.$t('role_permissions.saved'), 'success');
      }
    }
  }
</script>